module.exports = __webpack_public_path__ + "img/toledo.07824a3b.jpeg";